'use strict';

exports.Lodash = {
	Settings: {
		interpolate: /{{([\s\S]+?)}}/g
	}
}